import type { EducationItem } from "../../data/site";
import { Card } from "../ui/Card";
import "./education.css";

export function Education({ items }: { items: EducationItem[] }) {
  return (
    <div className="edu">
      {items.map((ed) => (
        <Card key={`${ed.school}-${ed.time}`}>
          <div className="edu__top">
            <div>
              <div className="edu__school">
                {ed.school}
                {ed.college ? <span className="edu__college"> · {ed.college}</span> : null}
              </div>
              <div className="edu__meta">
                {ed.stage}
                {ed.degreeType ? `（${ed.degreeType}）` : ""} · {ed.major}
              </div>
            </div>
            <div className="edu__time">{ed.time}</div>
          </div>

          <div className="edu__grid">
            <div>
              <div className="edu__label">核心课程</div>
              <div className="edu__tags">
                {ed.courses.map((c: string) => (
                  <span className="tag" key={c}>
                    {c}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <div className="edu__label">GPA / 排名</div>
              <div className="edu__honors">
                <div>{ed.gpa}</div>
                <div className="edu__rank">{ed.rankHint}</div>
              </div>
            </div>
          </div>

          {ed.courseHighlights.length ? (
            <div className="edu__hl">
              <div className="edu__label">课程亮点</div>
              <div className="edu__hlGrid">
                {ed.courseHighlights.map((x) => (
                  <div className="edu__hlItem" key={`${x.course}-${x.score}`}>
                    <span className="edu__hlCourse">{x.course}</span>
                    <span className="edu__hlScore">{x.score}</span>
                  </div>
                ))}
              </div>
            </div>
          ) : null}
        </Card>
      ))}
    </div>
  );
}

